export default __webpack_public_path__ + "static/media/scour_additional_info.ce622ee2.png";